import React from 'react';
export function Navigation() {
  const menuItems = [{
    label: 'Home',
    href: '#home'
  }, {
    label: 'Services',
    href: '#services'
  }, {
    label: 'About',
    href: '#about'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  return <nav className="w-full bg-red-600 shadow-lg" data-id="element-71">
      <div className="max-w-7xl mx-auto px-4" data-id="element-72">
        <ul className="flex items-center justify-center gap-8 py-1.5" data-id="element-73">
          {menuItems.map((item, index) => <li key={index} data-id="element-74">
              <a href={item.href} className="text-white text-lg font-bold hover:text-yellow-400 transition-colors" data-id="element-75">
                {item.label}
              </a>
            </li>)}
        </ul>
      </div>
    </nav>;
}